import { createFileRoute } from "@tanstack/react-router";
import { useTranslations } from "use-intl";
import { AuthShell } from "@/components/auth/auth-shell";
import { BrandPanel } from "@/components/auth/brand-panel";
import { FormPanel } from "@/components/auth/form-panel";
import { FormPanelHeader } from "@/components/auth/form-panel-header";
import { FormHeading } from "@/components/auth/form-heading";
import RegisterForm from "@/components/auth/RegisterForm";

export const Route = createFileRoute("/_auth/signup")({
  component: SignUpPage,
});

function SignUpPage() {
  const t = useTranslations();

  return (
    <AuthShell>
      <BrandPanel page="signup" />
      <FormPanel>
        <FormPanelHeader
          linkOpposite={{
            href: "/signin",
            prompt: t("auth.signup.have_account"),
            cta: t("auth.signup.link_signin"),
          }}
        />
        <FormHeading
          title={t("auth.signup.title")}
          description={t("auth.signup.desc")}
        />
        <RegisterForm />
      </FormPanel>
    </AuthShell>
  );
}
